import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const PaymentFailure = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, loading } = useAuth();
  const paymentId = searchParams.get('payment_id');
  const status = searchParams.get('status');

  const handleRetry = () => {
    navigate('/access-denied');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  const getErrorMessage = (status) => {
    switch (status) {
      case 'rejected':
        return 'Tu pago fue rechazado. Por favor verifica tus datos e intenta nuevamente.';
      case 'expired':
        return 'La sesión de pago ha expirado. Por favor intenta nuevamente.';
      case 'cancelled':
        return 'El pago fue cancelado. Puedes intentarlo cuando estés listo.';
      default:
        return 'Ocurrió un error con tu pago. Por favor intenta nuevamente.';
    }
  };

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0a1a2a 0%, #162a3d 100%)',
        color: 'var(--text-primary)'
      }}>
        <div>Cargando...</div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0a1a2a 0%, #162a3d 100%)',
      color: 'var(--text-primary)',
      fontFamily: 'var(--font-primary)',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <div style={{
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(10px)',
        padding: '3rem',
        borderRadius: '20px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        maxWidth: '500px',
        width: '100%',
        boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)'
      }}>
        <div style={{ fontSize: '5rem', marginBottom: '1rem' }}>❌</div>
        <h1 style={{
          margin: '0 0 1rem 0',
          fontSize: '2rem',
          background: 'linear-gradient(90deg, #ff5252 0%, #ff8a8a 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          Error en el Pago
        </h1>
        <p style={{
          color: 'var(--text-secondary)',
          lineHeight: '1.6',
          marginBottom: '1.5rem',
          fontSize: '1rem'
        }}>
          {getErrorMessage(status)}
        </p>
        {paymentId && (
          <p style={{
            color: 'var(--text-muted)',
            fontSize: '0.85rem',
            marginBottom: '1.5rem'
          }}>
            ID de transacción: <code style={{ background: 'rgba(255,255,255,0.1)', padding: '2px 6px', borderRadius: '4px' }}>{paymentId}</code>
          </p>
        )}
        <div style={{
          background: 'rgba(255, 82, 82, 0.1)',
          border: '1px solid rgba(255, 82, 82, 0.3)',
          borderRadius: '12px',
          padding: '1rem',
          marginBottom: '1.5rem',
          textAlign: 'left'
        }}>
          <h4 style={{ margin: '0 0 0.5rem 0', color: '#ff5252', fontSize: '0.9rem' }}>
            💡 Sugerencias
          </h4>
          <ul style={{ margin: 0, paddingLeft: '1.25rem', color: 'var(--text-secondary)', fontSize: '0.85rem' }}>
            <li>Verifica que tu tarjeta tenga fondos suficientes</li>
            <li style={{ marginTop: '0.5rem' }}>Asegúrate de que los datos de tu tarjeta sean correctos</li>
            <li style={{ marginTop: '0.5rem' }}>Contacta a tu banco si el problema persiste</li>
            <li style={{ marginTop: '0.5rem' }}>Intenta con otro método de pago</li>
          </ul>
        </div>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={handleRetry}
            style={{
              background: 'linear-gradient(135deg, #c5a059 0%, #dbb96a 100%)',
              border: 'none',
              padding: '12px 24px',
              color: '#0a1a2a',
              borderRadius: '50px',
              fontSize: '0.95rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s',
              boxShadow: '0 4px 15px rgba(197, 160, 89, 0.4)'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            Reintentar Pago
          </button>
          {!user && (
            <button
              onClick={handleLogin}
              style={{
                background: 'transparent',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                padding: '10px 24px',
                color: 'var(--text-primary)',
                borderRadius: '50px',
                fontSize: '0.95rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = 'transparent';
              }}
            >
              Iniciar Sesión
            </button>
          )}
        </div>
        <p style={{
          color: 'var(--text-muted)',
          fontSize: '0.8rem',
          marginTop: '1.5rem',
          marginBottom: 0
        }}>
          ¿Necesitas ayuda? Contacta a <a href="mailto:soporte@ascensosapp.com" style={{ color: 'var(--gold-matte)' }}>soporte@ascensosapp.com</a>
        </p>
      </div>
      <div style={{ marginTop: '2rem', color: 'var(--text-muted)', fontSize: '0.8rem' }}>
        Ascensos App © {new Date().getFullYear()}
      </div>
    </div>
  );
};

export default PaymentFailure;
